import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiRotateCcw, FiHome, FiTrophy, FiClock, FiMinus } = FiIcons;

const GameOverModal = ({ isOpen, gameStatus, winner, onPlayAgain, onGoToMenu }) => {
  const getModalContent = () => {
    switch (gameStatus) {
      case 'checkmate':
        return {
          icon: FiTrophy,
          title: 'Checkmate!',
          message: `${winner === 'white' ? 'White' : 'Black'} wins!`,
          color: 'from-yellow-500 to-orange-600'
        };
      case 'stalemate':
        return {
          icon: FiMinus,
          title: 'Stalemate!',
          message: 'The game is a draw',
          color: 'from-gray-500 to-gray-600'
        };
      case 'timeout':
        return {
          icon: FiClock,
          title: 'Time Up!',
          message: `${winner === 'white' ? 'White' : 'Black'} wins by timeout!`,
          color: 'from-red-500 to-red-600'
        };
      default:
        return {
          icon: FiTrophy,
          title: 'Game Over',
          message: 'Game finished',
          color: 'from-blue-500 to-purple-600'
        };
    }
  };

  const content = getModalContent();

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4 z-50"
        >
          <motion.div
            initial={{ scale: 0.8, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.8, opacity: 0, y: 20 }}
            className={`bg-gradient-to-br ${content.color} p-8 rounded-2xl shadow-2xl border border-white/20 max-w-md w-full text-center`}
          >
            <motion.div
              initial={{ scale: 0, rotate: -180 }}
              animate={{ scale: 1, rotate: 0 }}
              transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
              className="mb-6"
            >
              <SafeIcon icon={content.icon} className="text-6xl text-white mx-auto" />
            </motion.div>

            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
              className="text-3xl font-bold text-white mb-4"
            >
              {content.title}
            </motion.h2>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 }}
              className="text-xl text-white/90 mb-8"
            >
              {content.message}
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5 }}
              className="flex gap-4 justify-center"
            >
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={onPlayAgain}
                className="flex items-center gap-2 px-6 py-3 bg-white text-gray-800 rounded-lg font-semibold hover:bg-gray-100 transition-colors"
              >
                <SafeIcon icon={FiRotateCcw} />
                Play Again
              </motion.button>
              
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={onGoToMenu}
                className="flex items-center gap-2 px-6 py-3 bg-white/20 text-white border border-white/30 rounded-lg font-semibold hover:bg-white/30 transition-colors"
              >
                <SafeIcon icon={FiHome} />
                Main Menu
              </motion.button>
            </motion.div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default GameOverModal;